import React from 'react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-navy-deep px-4 py-14" aria-labelledby="ultimo" data-id="element-153" data-mp="5f3fysd94bms">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-154" data-mp="3mrnz62gn407e">
        <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-brandred" data-id="element-155" data-mp="3rrtjexkkykfg">
          Último llamado
        </p>
        <h2 id="ultimo" className="mt-3 font-display text-2xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-156" data-mp="3drsgzdoo34xv">
          La próxima vez que un paciente hipertenso entre a tu consulta, tendrás
          dos opciones
        </h2>
        <div className="mt-5 space-y-3 text-[15px] leading-relaxed text-white/75" data-id="element-157" data-mp="38t7ibip2ctbj">
          <p data-id="element-158" data-mp="1231afv5fqctk">
            Seguir improvisando entre diferentes guías, intentando recordar cuál era
            la recomendación correcta…
          </p>
          <p className="font-semibold text-white" data-id="element-159" data-mp="171up3qwgk9vb">
            O abrir una ruta clínica que ya organizó todo por ti: qué hacer, cuándo
            hacerlo y por qué hacerlo.
          </p>
          <p data-id="element-160" data-mp="l90v0fwgnvr8">
            La decisión que tomes hoy puede acompañarte en cientos de consultas
            futuras.
          </p>
        </div>

        <div className="mt-8" data-id="element-161" data-mp="uzbxdy0hxww0">
          <CTAButton label="Quiero Ruta Hipertensión por solo $14 USD" size="lg" note="Acceso inmediato · Pago único · Garantía de 7 días · Cambio de moneda automático" data-id="element-162" data-mp="uz3osibepdqm" />
        </div>

        <div className="mt-6" data-id="element-163" data-mp="2civ3b7gkpjw">
          <Countdown data-id="element-164" data-mp="gafvyjsy3i4d" />
        </div>

        <div className="mt-6" data-id="element-165" data-mp="gbijchr272fj">
          <ScarcityBar data-id="element-166" data-mp="gbqzqjme4pvh" />
        </div>
      </div>
    </section>;
}